export default __webpack_public_path__ + "16cca4fd2df42d99947e36dc23438891.svg";